import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t-2 border-black bg-white px-6 py-20 text-black">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-16">
        <div className="flex flex-col items-center gap-4">
          <p className="font-serif text-3xl font-black uppercase italic">
            Broadway Muses
          </p>
          <p className="font-mono text-[10px] font-black uppercase tracking-widest opacity-50">
            © {new Date().getFullYear()} All Rights Reserved
          </p>
        </div>

        <nav
          aria-label="Footer navigation"
          className="flex flex-wrap justify-center gap-x-12 gap-y-6 font-mono text-[10px] font-black uppercase"
        >
          <Link
            to="/contact"
            className="underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
          >
            Contact
          </Link>
          <Link
            to="/privacy"
            className="underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            className="underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
          >
            Terms of Service
          </Link>
          <Link
            to="/ada-statement"
            className="underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
          >
            ADA Statement
          </Link>
        </nav>

        <div className="flex w-full flex-col items-center gap-6">
          <div className="h-px w-24 bg-black/20" />
          <a
            href="https://mobilefirstpro.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-[10px] font-black uppercase underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
          >
            Made by MFP
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;